import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ActivityGridDataProviderFactory } from '../factory/ActivityGridDataProviderFactory';
import { ActivityGridBaseDataProvider } from '../dataProvider/ActivityGridBaseDataProvider';
import { ActivityGridViewData } from '../types';

export class ActivityGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ActivityGridDataProviderFactory;
  public dataProvider: ActivityGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ActivityGridDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<ActivityGridViewData> {
    return this.dataProvider.getDataForView();
  }
}
